import api from '@/api/axios';

const state = {
  gig_users: [],
  isLoading: false,
  error: null,
};

const mutations = {
  SET_GIG_USERS(state, gig_users) {
    state.gig_users = gig_users;
  },
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

const actions = {
  async fetchGigUsers({ commit, rootState }) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const token = rootState.auth.token;
      if (!token) {
        throw new Error('No authentication token found');
      }
      const response = await api.get('/api/v1/users/gig_users');
      commit('SET_GIG_USERS', response.data);
    } catch (error) {
      console.error('Failed to fetch GIG users:', error);
      commit('SET_ERROR', error.message || 'Failed to fetch GIG users');
    } finally {
      commit('SET_LOADING', false);
    }
  },
};

const getters = {
  allGigUsers: state => state.gig_users,
  isLoading: state => state.isLoading,
  error: state => state.error,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};